
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("gqMjf"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("gqMjf", function(module, exports) {

let $bf648c4e4febb987$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bf648c4e4febb987$var$load("h3ABO"),
    $bf648c4e4febb987$var$load("fSobj"),
    $bf648c4e4febb987$var$load("74u2y"),
    $bf648c4e4febb987$var$load("2YffH"),
    $bf648c4e4febb987$var$load("1aTst"),
    $bf648c4e4febb987$var$load("6mHrv"),
    $bf648c4e4febb987$var$load("awWN9"),
    $bf648c4e4febb987$var$load("9CYct"),
    $bf648c4e4febb987$var$load("d9JGW"),
    $bf648c4e4febb987$var$load("b8SC5"),
    $bf648c4e4febb987$var$load("hZtKG"),
    $bf648c4e4febb987$var$load("iNmaF"),
    $bf648c4e4febb987$var$load("lVO3w"),
    $bf648c4e4febb987$var$load("hyzoX"),
    $bf648c4e4febb987$var$load("h9Ed7"),
    $bf648c4e4febb987$var$load("eBRUf"),
    $bf648c4e4febb987$var$load("b2zxR"),
    $bf648c4e4febb987$var$load("tKhaz"),
    $bf648c4e4febb987$var$load("g2Huf"),
    $bf648c4e4febb987$var$load("cOwGZ"),
    $bf648c4e4febb987$var$load("cD6Zr"),
    $bf648c4e4febb987$var$load("dtASV"),
    $bf648c4e4febb987$var$load("hsJyN"),
    $bf648c4e4febb987$var$load("8YSo7"),
    $bf648c4e4febb987$var$load("g7ggm"),
    $bf648c4e4febb987$var$load("Wowvf"),
    $bf648c4e4febb987$var$load("9S9Mz"),
    $bf648c4e4febb987$var$load("kiGNy"),
    $bf648c4e4febb987$var$load("7do1E"),
    $bf648c4e4febb987$var$load("77dkW"),
    $bf648c4e4febb987$var$load("1MlIV"),
    $bf648c4e4febb987$var$load("g9CVe"),
    $bf648c4e4febb987$var$load("7oiUM"),
    $bf648c4e4febb987$var$load("8t3po"),
    $bf648c4e4febb987$var$load("855o0"),
    $bf648c4e4febb987$var$load("8MfZE"),
    $bf648c4e4febb987$var$load("hv4mn"),
    $bf648c4e4febb987$var$load("dek7I"),
    $bf648c4e4febb987$var$load("dYtBN"),
    $bf648c4e4febb987$var$load("6wr18"),
    $bf648c4e4febb987$var$load("kjZZD"),
    $bf648c4e4febb987$var$load("8iA2F"),
    $bf648c4e4febb987$var$load("4RhJO"),
    $bf648c4e4febb987$var$load("jsqco"),
    $bf648c4e4febb987$var$load("851iy"),
    $bf648c4e4febb987$var$load("37ldp"),
    $bf648c4e4febb987$var$load("ffEVr"),
    $bf648c4e4febb987$var$load("dRpV3"),
    $bf648c4e4febb987$var$load("dTsOE"),
    $bf648c4e4febb987$var$load("hhss7"),
    $bf648c4e4febb987$var$load("jwTn5"),
    $bf648c4e4febb987$var$load("aYdgM"),
    $bf648c4e4febb987$var$load("6u1hm"),
    $bf648c4e4febb987$var$load("klApM"),
    $bf648c4e4febb987$var$load("eQgf0"),
    $bf648c4e4febb987$var$load("8fMw3"),
    $bf648c4e4febb987$var$load("hogcU"),
    $bf648c4e4febb987$var$load("75xVF"),
    $bf648c4e4febb987$var$load("7EorR"),
    $bf648c4e4febb987$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.841299e5.js.map
